import { Injectable } from '@angular/core';
import { RecordSearchResponseData } from './models/record-search-response.data';
import { RecordSearch } from './models/record-search.model';
import { Util } from '../../../util';
import { Record } from '../../../models/record';

@Injectable({
  providedIn: 'root',
})
export class RecordsSearchFactory {
  buildSearchRecord(responseRecord: RecordSearchResponseData): RecordSearch {
    const icon = Util.resolveIcon(responseRecord as unknown as Record, responseRecord.iconId);

    return {
      id: responseRecord.id,
      title: responseRecord.title,
      icon,
      actions: responseRecord.actions ?? [],
      author: responseRecord.author,
      coverImageUrl: responseRecord.coverImageUrl,
      description: responseRecord.description,
      additionalData: responseRecord.additionalData,
    };
  }
}
